/**
 * Cron Explain Tool
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import { ToolError } from '@/engine/errors/ToolError';
import type { ITransformerTool } from '@/interfaces/ITool';

function unwrapDefault<T>(mod: unknown): T {
  const m = mod as Record<string, unknown> | null | undefined;
  return (m?.default ?? mod) as T;
}

export const CronExplainTool: ITransformerTool = {
  id: 'cron-explain',
  name: 'Cron Explain',
  description: 'Explain a cron expression in plain English',
  version: '1.0.0',
  type: 'transformer',
  category: 'Utilities',
  keywords: ['cron', 'schedule', 'explain', 'parser'],

  supportedInputTypes: [SEMANTIC_TYPES.TEXT],
  outputType: SEMANTIC_TYPES.TEXT,

  attributes: [
    {
      name: 'use24Hour',
      type: 'boolean',
      label: '24-hour Time',
      defaultValue: true,
      description: 'Prefer 24-hour time in the description',
    },
  ],

  async transform(input: string, config: Record<string, unknown>): Promise<string> {
    const text = String(input ?? '').trim();
    if (!text) return '';

    try {
      const mod = await import('cronstrue');
      const cronstrue = unwrapDefault<{ toString: (expr: string, opts?: Record<string, unknown>) => string }>(mod);
      const use24HourTimeFormat = config.use24Hour !== false;
      return cronstrue.toString(text, { use24HourTimeFormat });
    } catch (e) {
      const msg = e instanceof Error ? e.message : 'Invalid cron expression';
      throw ToolError.validation(msg);
    }
  },
};
